<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button class="button" disabled slot="trigger">
        IDs
      </button>
    </template>

    <b-dropdown-item
      @click="copyContent(transactionId, 'ID da transação copiado!')"
      aria-role="listitem"
    >
      <b>ID Onii: </b>{{ transactionId }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item
      v-if="merchantReference"
      @click="copyContent(merchantReference, 'Texto copiado!')"
      aria-role="listitem"
    >
      <b>Adyen merchantReference: </b>
      <br />
      {{ merchantReference }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  mixins: [common],

  props: ["transactionId", "merchantReference"]
};
</script>
